/* Reuse the inherited Aria widget; opening the panel never sends a message or starts a call. */
(() => {
  const root = document.getElementById('styles');
  const toggle = document.getElementById('lmGallerySupport');
  const widget = document.getElementById('lmAriaWidget');
  if (!root || !toggle || !widget || toggle.dataset.bound) return;
  toggle.dataset.bound = 'true';
  const mobile = window.matchMedia('(max-width: 899px)');
  const close = () => {
    root.dataset.lmSupportOpen = 'false';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = toggle.dataset.openLabel;
  };
  close();
  root.dataset.lmSupportReady = 'true';
  toggle.hidden = false;
  toggle.addEventListener('click', () => {
    const open = root.dataset.lmSupportOpen !== 'true';
    if (!open) { close(); return; }
    root.dataset.lmSupportOpen = 'true';
    toggle.setAttribute('aria-expanded', 'true');
    toggle.textContent = toggle.dataset.closeLabel;
    widget.setAttribute('default-expanded', 'true');
    widget.dispatchEvent(new CustomEvent('elevenlabs-agent:expand', {bubbles: true, detail: {action: 'expand'}}));
  });
  mobile.addEventListener('change', close);
})();
